<template>
    <div>
        <app-sub-title text="Consignas por aprobar" />
        <app-approval-duties-list
            :data="data"
            :on-change-page="onChangePage"
            :on-edit="startUpdate"
            :on-approve="startApprove"
        />
        <!-- PopUps -->
        <app-pop-up id="duty-update" title="Consigna">
            <div slot="body">
                <app-duty-form
                    id="duty-update"
                    :my-duty="dutySelect"
                    :the-client-id="dutySelect.client_id"
                    :on-save="onUpdate"
                ></app-duty-form>
            </div>
            <div slot="buttons">
                <button
                    class="btn btn-confirm"
                    :disabled="inProgress"
                    @click="$bus.$emit('duty-update.save')"
                >
                    Guardar
                </button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="duty-approve">
            <div slot="body">
                <h2>¿Esta seguro que desea aprobar esta consigna?</h2>
            </div>
            <div class="buttons" slot="buttons">
                <button
                    class="btn btn-confirm"
                    @click="approveDuty(dutySelect)"
                >
                    <i class="fa fa-check" aria-hidden="true"></i> Aprobar
                </button>
            </div>
        </app-pop-up>
        <!-- Fin PopUps -->
    </div>
</template>
<script>
import dutiesRepository from "../../../repositories/duties.repository.js";
import ApprovalDutiesList from "./ApprovalDutiesList/ApprovalDutiesList.vue";
import PopUp from "../../UI/Controls/PopUp/PopUp.vue";
import DutyForm from "../../Admin/Duties/DutyForm.vue";
export default {
    components: {
        appApprovalDutiesList: ApprovalDutiesList,
        appPopUp: PopUp,
        appDutyForm: DutyForm
    },

    data() {
        return {
            page: 1,
            data: {},
            dutySelect: ""
        };
    },

    methods: {
        loadDuties() {
            const dr = Object.assign({}, dutiesRepository);
            dr.loadDutiesSpecificsAndUnapproved(this.page)
                .then(data => {
                    this.data = data;
                })
                .catch(error => {
                    toastr.error("Ocurrió un error al cargar las consignas");
                });
        },
        onChangePage(page) {
            this.page = page;
            this.loadDuties();
        },
        startUpdate(duty) {
            this.dutySelect = duty;
            this.$bus.$emit("duty-update.open");
        },
        onUpdate() {
            this.loadDuties();
            this.$bus.$emit("duty-update.close");
        },
        startApprove(duty) {
            this.dutySelect = duty;
            this.$bus.$emit("duty-approve.open");
        },
        approveDuty(duty) {
            const formData = new FormData();
            formData.append("approvedById", this.user.id);

            const dr = Object.assign({}, dutiesRepository);
            dr.approveDuty(duty.id, formData)
                .then(data => {
                    toastr.success(data.msg);
                    this.loadDuties();
                    this.$bus.$emit("duty-approve.close");
                })
                .catch(error => {
                    toastr.error("Error al aprobar la consigna");
                });
        }
    },

    created() {
        this.loadDuties();
    }
};
</script>
